import type { ButtonType } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

const SETUP_NAME_BLURRED_BACKGROUND_IMAGE = AssetsService.assetUrl(
    "/images/activation/blurred-activation-background.png",
);

const MODAL_WIDTH = "720px";
const MODAL_HEIGHT = "620px";
const MAX_MODAL_HEIGHT = "800px";

const NAME_MODAL_WIDTH = "400px";

export const modalConfig = {
    content: {
        width: MODAL_WIDTH,
        padding: "20px 32px 16px 32px",
        border: "unset",
        minHeight: MODAL_HEIGHT,
        maxHeight: MAX_MODAL_HEIGHT,
    },
};

export const nameModalConfig = {
    overlay: {
        backgroundImage: `url(${SETUP_NAME_BLURRED_BACKGROUND_IMAGE})`,
        backgroundSize: "cover",
    },
    content: {
        width: NAME_MODAL_WIDTH,
        padding: "20px 24px 16px",
        border: "unset",
    },
};

export enum SETUP_STEPS_NAMES {
    SELECT_COMPETITORS = "SELECT_COMPETITORS",
    ENTER_NAME = "ENTER_NAME",
}

export enum SETUP_STEPS {
    "SELECT_COMPETITORS",
    "ENTER_NAME",
}

export const getCloseButton = () => ({
    label: translate("global.cancel"),
    type: "flatDark" as ButtonType,
    tooltipEnabled: false,
});

export const getBackButton = () => ({
    type: "flat" as ButtonType,
    label: translate("activation.topics.modal.button.back"),
    tooltipEnabled: false,
});

export const getFinishButton = () => ({
    label: translate("benchmarkingTrackerWizardModal.button.finish"),
    type: "primary" as ButtonType,
    tooltipEnabled: false,
});

export const DEFAULT_ACTIVATION_SET_NAME = "Project:";
export const MAX_CHARACTERS = 40;
export const MAX_CHARACTERS_IN_INPUT = 41;
export const MIN_CHARACTERS = 2;
export const CHAR_REASONING_LIMIT_SIZE = 68;
